export default "__VITE_ASSET__$PoXEe71__"